import PrivateRoute from 'utils/privateRoute';
import EnterprisePlatformDashboard from 'components/EnterprisePlatform/Platform';

const EnterprisePlatformRoutes = [
    {
        key: 'ent_pl_dash',
        route: '/enterprisePlatform/dashboard',
        component: (
            <PrivateRoute
                Component={EnterprisePlatformDashboard}
                restrictedRoles={['Data Operations Admin', 'Data Operations User', 'D&AI Executive User', 'Program Executive']}
            />
        )
    },
];

export default EnterprisePlatformRoutes;